<template>
    <div class="customFormWrapper" v-loading="pageLoading">
        <el-card class="box-card" v-for="(group,index) in groupList" :key="index" style="margin-bottom: 10px;">
            <div slot="header" class="clearfix">
                <span>{{ group.title }}</span>
            </div>
            <!--  表单数据  -->
            <el-form v-if="group.contentType === 0"
                     label-width="200px"
                     style="display: flex;flex-wrap: wrap;justify-content: space-between"
            >
                <el-form-item v-for="(cellItem,i) in group.dataList"
                              v-if="cellItem.showInList"
                              :key="i"
                              :label-width="cellItem.textType === 0?'0px':'200px'"
                              :class="[
                                  {
                                  'single-row':(cellItem.columnCount == '1' || cellItem.columnType  == '3' ),
                                  'double-row':(cellItem.columnCount == '2' && cellItem.columnType  != '3' ),
                                  'third-row':(cellItem.columnCount == '3' && cellItem.columnType  != '3'),
                                  },
                                  cellItem.columnName
                              ]"
                >
                    <template slot="label" v-if="cellItem.textType === 1">
                        <span :key="'lb'+i" style="display:inline-block;width:174px">{{ cellItem.title }}</span>
                        <span :key="'a'+i" style="display:inline-block;vertical-align: top;">：</span>
                    </template>
                    <template>
                        <dialog-open-btn-item v-if="cellItem.columnType === '1'"
                                              :key="randerTimeKey()"
                                              :parent-id="cellItem.value"
                                              :param-map="paramMap"
                                              :config="parseSource(cellItem.datasource,{'toChild':toChild})"/>
                        <div v-else-if="cellItem.columnType === '3'"
                             :key="i"
                             v-html="cellItem.value"
                             style="text-align: left"
                        ></div>
                        <custom-sub-item v-else-if="cellItem.columnType === '4'"
                                         :parent-id="cellItem.value"
                                         :param-map="paramMap"
                                         :config="parseSource(cellItem.datasource,{'toChild':toChild})"/>
                        <span v-else-if="cellItem.columnType === '5' || cellItem.columnType === '6'"
                              :key="i"
                              style="text-align: center">
                            <el-link v-if="cellItem.datasource.indexOf('http') > -1" type="primary" :underline="false"
                                     :href="baseUrlBase + cellItem.datasource?parseSource(cellItem.datasource).url:''"
                                     target="_blank">{{ cellItem.title }}
                            </el-link>
                            <el-button v-else
                                       :type="cellItem.columnType === '6'?'text':'primary'"
                                       size="mini"
                                       @click.stop="buttonClick(parseSource(cellItem.datasource).url,cellItem.columnType)"
                                       :underline="false">{{ cellItem.title }}
                            </el-button>
                        </span>
                        <inner-iframe-item :key="randerTimeKey()" v-else-if="cellItem.columnType === '7'"
                                           :value="cellItem.value"
                                           :param-map="paramMap"
                                           :config="parseSource(cellItem.datasource,{'toChild':toChild})"/>
                        <attachment-list-item :key="randerTimeKey()" v-else-if="cellItem.columnType === '8'"
                                              :parent-id="cellItem.value"
                                              :param-map="paramMap"
                                              :config="parseSource(cellItem.datasource,{'toChild':toChild})"
                                              :filingCBtn="filingCBtn"
                                              :handleSignFunc="handleSignFunc"
                        />
                        <warn-record-item v-else
                                          :key="randerTimeKey()"
                                          :data="cellItem"
                                          :form-info="formInfo"
                        />
                    </template>
                </el-form-item>
            </el-form>
            <!--  表格数据  -->
            <div v-else-if="group.contentType === 1 && group.fieldList.length > 0">
                <div v-if="group.queryParamList.length > 0">
                    <el-form class="form viewFormWrapper" :inline="true">
                        <el-form-item :label="item.displayName+'：'" class="searchInForm"
                                      v-for="(item, index) in group.queryParamList" :key="index">
                            <el-input v-model="searchForm[item.paramsName]" placeholder="请输入内容"></el-input>
                        </el-form-item>
                        <el-button size="small" type="primary" style="margin-left:30px;"
                                   @click="getCustomDataDetail('searchList',group.groupId)">搜索
                        </el-button>
                        <el-button plain size="small" type="primary" style="margin-left:10px;"
                                   @click.prevent="getCustomDataDetail('searchList',0)">重置
                        </el-button>
                    </el-form>
                </div>
                <el-table v-if="group.rowList.length > 0" :data="group.rowList" border stripe style="width: 100%">
                    <el-table-column v-for="item in group.fieldList" :key="item.id" :label="item.displayName"
                                     :prop="item.columnName" :width="item.columnWidth?item.columnWidth:'auto'">
                        <template slot-scope="scope">
                            <span v-if="item.columnName == item.key && item.showInList && item.key == 'id' && item.id">
                                <el-button type="text" title="查看"
                                           @click="getCustomDataDetail(scope.row.id, null)">查看</el-button>
                            </span>
                            <span v-else :style="scope.row[item.style]">{{ scope.row[item.columnName] }}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="group.rowList.length == 0" style="text-align: center;margin-top: 20px;">暂无数据</div>
                <div v-if="group.isMore" style="text-align: center;margin-top: 20px; text-decoration: none;">
                    <span class="link" @click="loadMore(group.groupId)">点击加载更多...</span>
                </div>
            </div>
            <!--  表单集合  -->
            <div v-else-if="group.contentType === 2 && group.collList.length > 0">
                <coll-list-item :coll-list="group.collList"
                                :param-map="paramMap"
                                :to-child="toChild"
                                :form-info="formInfo"
                ></coll-list-item>
            </div>
            <p v-if="(group.contentType==0 && group.dataList.length == 0)||(group.contentType==1 && group.fieldList.length == 0) || (group.contentType==2 && group.collList.length == 0)"
               style="text-align: center">暂无数据</p>
        </el-card>
        <!-- 无表单数据 -->
        <el-card class="box-card" v-if="groupList.length == 0"
                 style="height: 600px;position: relative;margin-bottom: 10px;">
            <emptyInfo v-if="groupList.length == 0" :emptyMsg="'暂无表单数据'"></emptyInfo>
        </el-card>
        <!-- 附件数据 -->
        <el-card class="box-card" v-if="formInfo.hasAttach != undefined && formInfo.hasAttach != ''">
            <div slot="header" class="clearfix">
                <span>附件列表</span>
            </div>
            <template>
                <div class="affixDown" v-if="attachmentList.length > 0" style="margin-bottom: 10px"
                     v-loading="refreshLoading">
                    <affix-doc v-for="(item,index) in attachmentList"
                               :item.sync="item"
                               labelWidth="200px"
                               :index="index"
                               :key="index"
                               @refreshPdf="refreshFn"
                               :filingCBtn="attSignShow(item)&&filingCBtn"
                               @updateItem="updateItem"
                               :showModal="false"
                               :name="item.titleName"
                               :handleSignFunc="handleSignFunc"
                    >
                    </affix-doc>
                </div>
                <p style="text-align: center" v-if="attachmentList.length == 0">暂无附件数据</p>
            </template>
        </el-card>
        <!-- 监督记录 -->
        <audit-history v-if="showAuditHistory"
                       ref="auditHistoryRef"
        ></audit-history>
    </div>
</template>

<script>

import {
    apiAttachmentGetAttachmentByBizId,
    apiAttachmentGetDataByCodeAndEid,
    apiAuditHistoryGetListAudit,
    apiBusinessFlowNodeWitness,
    apiCustomformQueryDetail,
    apiTextguardianTextHandleReplaceText,
} from "../../server/formRender";
import warnRecordItem from "./WarnRecordItem";
import customSubItem from "./CustomSubItem";
import collListItem from "./CollListItem";
import {parseSource, randerTimeKey} from "../../utils/utils";
import emptyInfo from "./EmptyInfo";
import dialogOpenBtnItem from "./DialogOpenBtnItem";
import innerIframeItem from "./InnerIframeItem";
import attachmentListItem from "./AttachmentListItem";
import affixDoc from "./AffixDoc";
import AuditHistory from "./AuditHistory";
import {post} from "../../server/request";

export default {
    name: 'pm-form-render',
    components: {
        warnRecordItem,
        customSubItem,
        collListItem,
        emptyInfo,
        dialogOpenBtnItem,
        innerIframeItem,
        attachmentListItem,
        affixDoc,
        AuditHistory,
    },
    props: {
        filingCBtn: { //控制签章按钮是否显示？
            type: Boolean,
            defalut: false
        },
        toChild: {
            type: Boolean,
            defalut: false
        },
        handleSignFunc: { //处理签章的方法
            type: Function,
            require: false,
        },
        handleSignCallback: { //签章完之后的回调
            type: Object,
            default: () => ({}),
        }
    },
    watch: {
        handleSignCallback: { //监听签章完之后的回调
            handler(val) {
                console.log(val)
            },
            deep: true
        },
    },
    data() {
        return {
            formId: '',
            refreshLoading: false,
            groupList: [],
            paramMap: {},
            baseUrlBase: '',
            attachmentList: [],
            visible: false,
            // 查询附件所需参数
            entityIdCopy: "",
            // 查询附件所需参数
            // categoryCodeCopy: "",
            formInfo: {
                hasAttach: false,
            },
            itemList: [],
            searchForm: {},
            pageLoading: false,
            tableData: [],
            randerTimeKey: randerTimeKey,
            parseSource: parseSource,
            showAuditHistory: !this.$customFormGlobalConfig.selfRenderHistory, //是否自己处理工作流
        }
    },
    methods: {
        attSignShow(item){
            var mark = item.attributes
            if(mark && mark.showSignBtn){
                return true
            }
            return false
        },
        //更新附件
        updateItem(index, filePath){
            console.log('updateItem',index,filePath)
            const item = this.attachmentList[index]
            this.$set(this.attachmentList, index, { ...item, filePath: filePath})
        },
        // 查询附件
        getAttachments() {
            const entityId = this.paramMap.entityId;
            // console.log(this.formInfo.hasAttach, entityId, this.categoryCode, this.entityId)
            // this.paramMap.categoryCode = this.categoryCode
            if (this.formInfo.hasAttach && entityId != '' && this.paramMap.categoryCode != '') {
                if (!this.paramMap.categoryIsOpen) {  // 不支持附件类别约束
                    apiAttachmentGetAttachmentByBizId(entityId).then(({data}) => {
                        if (data.code == "1") {
                            this.attachmentList = data.data || [];
                            this.attachmentList.forEach((item) => {
                                item.titleName = '相关附件'
                            })
                        } else {
                            this.attachmentList = [];
                        }
                    });
                } else {
                    apiAttachmentGetDataByCodeAndEid(this.paramMap.categoryCode, entityId).then(({data}) => {
                        if (data.code == "1") {
                            let resData = data.data;
                            if (resData.length > 0) {
                                let arr = [];
                                for (var i = 0; i < resData.length; i++) {
                                    let attachmentObj = JSON.parse(JSON.stringify(resData[i]));
                                    if (attachmentObj.attFiles.length > 0) {
                                        for (var j = 0; j < attachmentObj.attFiles.length; j++) {
                                            let attachmentItem = JSON.parse(JSON.stringify(attachmentObj.attFiles[j]));
                                            attachmentItem.titleName = attachmentObj.name;
                                            attachmentItem.hideLable = (j == 0 ? false : true);
                                            arr.push(attachmentItem)
                                        }
                                    } else {
                                        arr.push({
                                            titleName: attachmentObj.name,
                                            name: '',
                                            filePath: '',
                                            hideLable: false
                                        })
                                    }
                                }
                                this.attachmentList = arr;
                                console.log(this.attachmentList)
                            } else {
                                this.attachmentList = [];
                            }
                        } else {
                            this.attachmentList = [];
                        }
                    });
                }
            } else {
                this.attachmentList = [];
            }
            setTimeout(() => {
                this.refreshLoading = false;
            }, 500)
        },
        //刷新文件数据
        refreshFn() {
            this.refreshLoading = true;
            this.getAttachments()
        },
        GetRequest(href) {
            var url = href.substring(href.indexOf("?")); //获取url中"?"符后的字串
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                var str = url.substr(1);
                var strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        },
        //按钮点击事件
        buttonClick(src, type) {
            // type ==5 按钮，type ==6 链接
            let params = this.GetRequest(src)
            var getBase = src.indexOf("?") > -1 ? src.substring(0, src.indexOf("?") + 1) : '';
            for (var i in params) {
                let value = params[i];
                let variable = value.indexOf('${') > -1;
                if (value.indexOf('${') > -1 || value.indexOf('}') > -1) {
                    value = value.replace('${', '');
                    value = value.replace('}', '');
                }
                getBase += `&${i}=${variable ? this.paramMap[value] || "" : value}`
            }

            let srcReq = getBase.replace('?&', '?');
            if (type === '6') { // type ==6 链接

                this.$router.push({
                    path: srcReq,
                });

            } else {
                post(srcReq, {}, {baseURL: '/api'}).then(res => {
                    if (res.data.code === '1') {
                        window.open(res.data.data, '_target')
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            }
        },


        //获取详情数据
        customformQueryDetail(formId, paramMap, config = {}) {
            // formId=自定义表单id ,paramMap= 项目数据参数 ，getAttByEntityId = 是否通过查询 entityId 和 已传参数categoryCode 查询附件数据及监督记录数据，detailId =  招标文件澄清与修改及资审文件澄清与修改 查看详情数据的id
            this.formId = formId;
            const _this = this;
            if (config.detailId && config.detailId != 'searchList') {
                this.paramMap.id = config.detailId;
            }

            if (config.groupId) {
                this.itemList.forEach((item) => {
                    if (item.groupId == config.groupId) {
                        config.detailId == 'searchList' ? item.rows = 20 : item.rows += 20;
                        for (var key in _this.searchForm) {
                            if (key.toString().indexOf(item.groupId) > -1) {
                                let val = _this.searchForm[key]
                                let column = key.split("-")[1]
                                item[column] = val;
                            }
                        }
                    }
                })
            } else {
                this.itemList = [];
                for (var key in _this.searchForm) {
                    _this.$set(_this.searchForm, key, "")
                }
            }
            // 优化接口参数
            this.paramMap.itemList = this.itemList;
            // 重新定义查询参数，避免污染全局 paramMap 对象
            let paramsMapTemp = {
                ...this.paramMap,
                applyCode: this.paramMap.applyCode == '-1' ? '' : this.paramMap.applyCode,
                idcard: this.paramMap.idcard == '-1' ? '' : this.paramMap.idcard,
            }
            // let paramsMapTemp = JSON.parse(JSON.stringify(paramMap || this.paramMap))
            // paramsMapTemp.applyCode = paramsMapTemp.applyCode == '-1' ? '' : paramsMapTemp.applyCode;
            // paramsMapTemp.idcard = paramsMapTemp.idcard == '-1' ? '' : paramsMapTemp.idcard;
            // paramsMapTemp.id = paramsMapTemp.entityId || '';
            if (config.businessType == 'CG') { // 采购业务重写 查询参数
                paramsMapTemp.purchaseProjectCode = paramsMapTemp.tenderProjectCode
                paramsMapTemp.purchaseSectionCode = paramsMapTemp.bidSectionCode
            }
            // 重置附件及审核列表数据
            // this.auditHisTableCopy = [];
            this.attachmentList = [];

            console.log('formId=====',formId)
            if (formId) {
                this.pageLoading = true;
                apiCustomformQueryDetail(formId, paramsMapTemp).then(({data}) => {
                    this.pageLoading = false;
                    if (JSON.stringify(data) != "{}") {
                        this.groupList = data.data;
                        let sign = this.itemList.length > 0 ? false : true;
                        this.groupList.forEach((item) => {
                            if (item.contentType == 1) {
                                item.queryParamList && item.queryParamList.forEach((itm) => {
                                    itm.paramsName = item.groupId + '-' + itm.columnName
                                })
                                if (sign) {
                                    let obj = {};
                                    obj.groupId = item.groupId;
                                    obj.datasetId = item.datasetId;
                                    obj.rows = 20;
                                    this.itemList.push(obj);
                                }
                                // item.isMore = item.rowList.length >= 20;
                            }

                            if(this.$customFormGlobalConfig.handleReplaceText && item.contentType == 0) {
                                item.dataList.forEach((dataItem) => {
                                    if(dataItem.columnType === '3') {
                                        const params = {content: dataItem.value}
                                        apiTextguardianTextHandleReplaceText(params).then(({data}) => {
                                            if(data.code === '1') {
                                                dataItem.value = data.data.text;
                                            }
                                        })
                                    }
                                })
                            }

                        });
                        this.formInfo = data.form;

                        // 是否通过查询 EntityId 查询附件及审核信息数据 ，自定义表单内部表格点击事件不需要查询 EntityId，本身带有 entityId
                        if (!config.getAttByEntityId && config.detailId) {
                            this.paramMap.entityId = config.detailId;
                        }
                        this.getAttachments();
                        this.showAuditHistory && this.$refs.auditHistoryRef && this.$refs.auditHistoryRef.getAuditHisList(this.paramMap.entityId)
                    } else {
                        this.groupList = [];
                        this.formInfo = {}
                    }
                });

            } else {
                this.groupList = [];
                this.formInfo = {};
            }
        },
        //获取表单数据
        async getCustomData(formId, paramMap = {}, config = {}) {
            console.log('getCustomData====formId===',formId)
            console.log('getCustomData====paramMap===', paramMap)
            console.log('getCustomData====config===', config)
            this.paramMap = paramMap;
            if (config.getAttByEntityId) {
                // 是否通过查询 EntityId 查询附件及审核信息数据 ，自定义表单内部表格点击事件不需要查询 EntityId，本身带有 entityId
                apiBusinessFlowNodeWitness(paramMap.projectCode, paramMap.tenderProjectCode, paramMap.bidSectionCode, paramMap.datasetCode).then(res => {
                    if (res.data.code == '1') {
                        let responseId = res.data.data || '';
                        this.paramMap.entityId = responseId;
                    } else {
                        this.paramMap.entityId = '';
                        this.attachmentList = [];
                    }
                    console.log('customformQueryDetail')
                    this.customformQueryDetail(formId, this.paramMap, config)
                })
            } else {
                if (config.detailId && config.detailId != 'searchList') {
                    this.paramMap.entityId = config.detailId;
                    this.paramMap.id = config.detailId
                }
                this.customformQueryDetail(formId, this.paramMap, config)
            }
        },
    }
}
</script>


<style lang="less" scoped>
@import "../../css/index.scss";
//.box-card {
//    margin-bottom: 10px;
//    .el-card__header {
//        span {
//            border-left: 3px solid rgb(25, 101, 255);
//            padding-left: 10px;
//            font-size: 16px;
//        }
//    }
//}
</style>

<style lang="less" scoped>
.mistaken-word {
    text-decoration: underline wavy;
    color: red;
}

.red-wave {
    background-color: yellow;
}
</style>

